import React from 'react';
import { Helmet } from 'react-helmet-async';

interface CoreMetaTagsProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  h1Title?: string;
  author?: string;
  robots?: string;
  language?: string;
  noIndex?: boolean;
  geoData?: {
    latitude?: number;
    longitude?: number;
    region?: string;
    country?: string;
  };
}

const CoreMetaTags: React.FC<CoreMetaTagsProps> = ({
  title,
  description,
  keywords,
  canonicalUrl,
  h1Title,
  author = "Global Therapy Connect",
  robots = "index, follow",
  language = "en",
  noIndex = false,
  geoData
}) => {
  const finalRobots = noIndex ? "noindex, nofollow" : robots;
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content={finalRobots} />
      <meta name="language" content={language} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Geographic Meta Tags */}
      {geoData?.latitude && geoData?.longitude && (
        <>
          <meta name="geo.position" content={`${geoData.latitude};${geoData.longitude}`} />
          <meta name="ICBM" content={`${geoData.latitude}, ${geoData.longitude}`} />
        </>
      )}
      
      {geoData?.region && (
        <meta name="geo.region" content={geoData.region} />
      )}
      
      {geoData?.country && (
        <meta name="geo.country" content={geoData.country} />
      )}
      
      {/* Additional SEO Meta Tags */}
      <meta name="distribution" content="global" />
      <meta name="revisit-after" content="7 days" />
      <meta name="rating" content="general" />
      
      {/* Viewport and Mobile Optimization */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="theme-color" content="#3B82F6" />
      
      {/* Performance Optimization */}
      <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      <link rel="dns-prefetch" href="//www.google-analytics.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

export default CoreMetaTags;